import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import { DossierIntervention } from 'app/models/dossier_intervention.model';
import { UserService as CoreUserService } from 'app/core/user/user.service';
import { User } from 'app/models/user.model';
import { Comment } from 'app/models/comment.model';
import { User as CoreUser } from 'app/core/user/user.types';
import {forEach, orderBy} from 'lodash-es';
import {CommentService} from '../../../../services/comment.service';

@Component({
  selector: 'app-communication',
  templateUrl: './communication.component.html'
})
export class CommunicationComponent implements OnInit {
    @Input() currentDossierIntervention: DossierIntervention = new DossierIntervention();
    @Input() users: User[] = [];
    authUser: CoreUser;

    comments: Comment[] = [];

    isLoaded = false;
    constructor(
        private _userService: CoreUserService,
        private commentService: CommentService
    ) { }

    ngOnInit(): void {
        this._userService.user$
            .subscribe((user: CoreUser) => {
                this.authUser = user;
            });

        this.fetchComments();
    }

    fetchComments(): void {
        this.isLoaded = false;

        this.commentService.getComments(this.currentDossierIntervention.id).subscribe((comments) => {
            const formattedComments = {};
            //Add parents
            forEach(comments.filter(comment => !comment.parent_id), (comment) => {
                formattedComments[comment.id] = new Comment(comment);
            });

            //Add childs
            forEach(comments.filter(comment => !!comment.parent_id), (comment) => {
                formattedComments[comment.parent_id].children.push(new Comment(comment));
            });

            this.comments = orderBy(formattedComments, ['created_at'], ['desc']);
            this.isLoaded = true;
        });
    }

    saveComment(comment): void {
        comment.user_id = parseInt(this.authUser.id, 10);
        comment.dossier_intervention_id = this.currentDossierIntervention.id;
        this.commentService.saveComment(comment).subscribe(() => {
            this.fetchComments();
        });
    }
}
